var map = {
	"./Chinese Classical.webp": 5037,
	"./Chinese Reading.webp": 7568,
	"./Chinese Writing.webp": 2988,
	"./Chinese.webp": 7748,
	"./English Reading.webp": 563,
	"./English Writing.webp": 1103,
	"./English.webp": 3159,
	"./General Chinese.webp": 6088,
	"./General English.webp": 9011,
	"./Math.webp": 227,
	"./Putonghua.webp": 8578,
	"./Science.webp": 5429,
	"./chi_marking_scheme.webp": 8593,
	"./eng_marking_scheme.webp": 6035,
	"./tailorQuestion.webp": 7946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4347;